import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface IDiscountAffiliate {
  name: string
  commission_rate: number
}

export interface IDiscountData {
  discount_code: string
  discount_percentage: number
  original_amount: number
  expires_at: string
  affiliate?: IDiscountAffiliate
}

interface IDiscountStore {
  discountCode: string
  discountData: IDiscountData | null
  setDiscountCode: (code: string) => void
  setDiscountData: (data: IDiscountData | null) => void
  clearDiscount: () => void
}

export const useDiscountStore = create<IDiscountStore>()(
  persist(
    (set) => ({
      discountCode: '',
      discountData: null,
      setDiscountCode: (code) => set({ discountCode: code }),
      setDiscountData: (data) => set({ discountData: data }),
      clearDiscount: () => set({ discountCode: '', discountData: null }),
    }),
    {
      name: 'discount-storage', // unique name for localStorage key
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      partialize: (state) => ({
        discountCode: state.discountCode,
        discountData: state.discountData,
      }), // (optional) choose which part of the state to persist
    }
  )
) 